<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-data-table
			:headers="headers"
			:items="contestData"
			class="elevation-1"
			hide-actions>
			<template v-slot:items="props">
				<td>{{ props.item.contestName }}</td>
				<td class="text-xs-center">{{ props.item.numberOfOffers}}</td>
				<td class="text-xs-center">{{ props.item.numberOfProjects}}</td>
				<td class="text-xs-center">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon @click="showContestSummary(props.item)">
								<v-icon v-on="on">
									ballot
								</v-icon>
							</v-btn>
						</template>
						<span>Podsumowanie konkursu</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {PublicContest} from "../../../api/generated/PublicContest";

	export default {
		name: "BidderContestList",
		created () {
			this.loadContestData();
		},

		data () {
			return {
				headers: [
					{text: "Nazwa konkursu", value: "contestName", sortable: true},
					{text: "Liczba ofert", value: "numberOfOffers", sortable: true, align: "center"},
					{text: "Liczba projektów", value: "numberOfProjects", sortable: false, align: "center"},
					{text: "Akcje", sortable: false, align: "center"},
				],
				contestData: []
			};
		},
		methods: {
			loadContestData () {
				PublicContest.getBidderContestStats(this, this.$route.params.bidderId, successResponse => {
					this.contestData = successResponse;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wczytac krajów przeznaczenia", errorResponse);
				});
			},
			showContestSummary (item) {
				this.$router.push("/app/contest/" + item.contestId + "/summary");
			}
		}
	};
</script>

<style scoped>

</style>
